import React, { Component, PropTypes } from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  competitions,
  genders,
  individualCategories,
  pasdedeuxCategories,
  squadCategories,
} from '../../constants/values';
import { Input } from '../inputs';

export default class EntryFilter extends Component {
  static propTypes = {
    onChangedFilter: PropTypes.func.isRequired,
    registeredNations: PropTypes.array.isRequired,
    filters: PropTypes.object.isRequired,
    hideNation: PropTypes.bool,
    isAdmin: PropTypes.bool,
  };

  handleChangeFilter = e => {
    const { onChangedFilter } = this.props;
    const { target } = e;

    const filterName = target.id.replace('input_', '');
    const filterValue =
      target.value === 'empty' || (target.type === 'text' && target.value === '')
        ? undefined
        : target.value;

    onChangedFilter(filterName, filterValue);
  };

  render() {
    const { filters, hideNation, isAdmin, registeredNations } = this.props;

    let categories;

    switch (filters.competition) {
      case 'INDIVIDUALS':
        categories = individualCategories;
        break;
      case 'PASDEDEUX':
        categories = pasdedeuxCategories;
        break;
      case 'SQUAD':
        categories = squadCategories;
        break;
      default:
    }

    return (
      <form>
        <Row>
          <Col xs={12} sm={3}>
            <Input
              type="select"
              onChange={this.handleChangeFilter}
              value={filters.competition}
              name="competition"
              label="Competition"
            >
              {competitions.map(competition => (
                <option key={competition.value} value={competition.value}>
                  {competition.name}
                </option>
              ))}
            </Input>
          </Col>

          {!hideNation && (
            <Col xs={12} sm={3}>
              <Input
                type="select"
                onChange={this.handleChangeFilter}
                value={filters.nation}
                name="nation"
                label="Nation"
              >
                <option value="empty">all</option>
                {registeredNations.map(nation => (
                  <option key={nation.value} value={nation.value}>
                    {nation.name}
                  </option>
                ))}
              </Input>
            </Col>
          )}

          <Col xs={12} sm={3}>
            <Input
              type="select"
              onChange={this.handleChangeFilter}
              value={filters['details.category']}
              name="details.category"
              label="Category"
            >
              <option value="empty">all</option>
              {categories.map(category => (
                <option key={category.value} value={category.value}>
                  {category.name}
                </option>
              ))}
            </Input>
          </Col>

          {filters.competition &&
            filters.competition === 'INDIVIDUALS' && (
              <Col xs={12} sm={3}>
                <Input
                  type="select"
                  onChange={this.handleChangeFilter}
                  value={filters['details.vaulterGender']}
                  name="details.vaulterGender"
                  label="Gender"
                >
                  <option value="empty">all</option>
                  {genders.map(gender => (
                    <option key={gender.value} value={gender.value}>
                      {gender.name}
                    </option>
                  ))}
                </Input>
              </Col>
            )}

          {isAdmin && (
            <Col xs={12} sm={3}>
              <Input
                type="text"
                onChange={this.handleChangeFilter}
                value={filters['details.horseName']}
                name="details.horseName"
                label="Horse Name"
              />
            </Col>
          )}

          {isAdmin && (
            <Col xs={12} sm={3}>
              <Input
                type="text"
                onChange={this.handleChangeFilter}
                value={filters['details.lungerLastName']}
                name="details.lungerLastName"
                label="Lunger Last Name"
              />
            </Col>
          )}
        </Row>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/entry/EntryFilter.js